export enum TransferType {
    Unknown = 'Unknown',
    PersonToPerson = 'PersonToPerson',
    GroupToPerson = 'GroupToPerson',
    PersonToGroup = 'PersonToGroup',
    GroupToGroup = 'GroupToGroup',
}
